module.exports = __webpack_public_path__ + "img/01_2_Linet_Ave_2_Retractable_Foot_Section.8a4bee8a.jpg";